import { render } from "./FormCheckbox.vue?vue&type=template&id=46b5cff6"
import script from "./FormCheckbox.vue?vue&type=script&lang=ts"
export * from "./FormCheckbox.vue?vue&type=script&lang=ts"
script.render = render

export default script